import React, { useEffect, useState } from "react";
import axios from "axios";
import "./CSS/UserDashbaord.css"; // keep your styles here

interface ProjectDetail {
  projectname: string;
  adminname: string;
  adminEmail: string;
}

export default function UserDashboard() {
  const [projects, setProjects] = useState<ProjectDetail[]>([]);
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const userEmail = localStorage.getItem("userEmail");

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        if (!userEmail) {
          console.error("User email not found in localStorage.");
          return;
        }

        const response = await axios.get(
          `https://timetrakerapi.sntservices.in/GetUserProjectDetails?Email=${encodeURIComponent(
            userEmail
          )}`
        );
        setProjects(response.data);
      } catch (error) {
        console.error("Error fetching user projects:", error);
      }
    };

    fetchProjects();
  }, [userEmail]);

  const toggleCard = (index: number) => {
    setExpandedIndex(index === expandedIndex ? null : index);
  };

  return (
    <div className="teambg10">
      <center>
        <h1>Employee Project List</h1>
      </center>
      <hr />
      <br />
      <div className="summary-container">
        <h2>Total Projects: {projects.length}</h2>
        {projects.map((project, index) => (
          <div
            key={index}
            className="employee-card"
            onClick={() => toggleCard(index)}
          >
            <div className="employee-header">
              <h3>{project.projectname}</h3>
            </div>
            {expandedIndex === index && (
              <div className="project-list">
                <h4 style={{ textDecoration: "underline" }}>Admin Info:</h4>
                <ul>
                  <li>
                    <strong>Name:</strong> {project.adminname}
                  </li>
                  <li>
                    <strong>Email:</strong> {project.adminEmail}
                  </li>
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
